import React, { memo } from 'react'
import { MainUI } from './presenter/ui/UI'
import TodoApi from './infrastructure/api/Api';
import { Service } from './usecase/Service';
import Handler from "./presenter/handler/Handler"

 function WorkflowTodoComponent() {
  const api = TodoApi();
  const service = Service(api);
  const handler = Handler(service);

  return (
    <MainUI handler={handler} />
  )
}

export default memo(WorkflowTodoComponent)
